import { Component, TemplateRef, ViewChild, OnInit, ViewChildren, QueryList, ElementRef, Input, DoCheck, Output, EventEmitter } from '@angular/core';
import { NavigationEnd, Router, IsActiveMatchOptions } from '@angular/router';
import { UserService } from '../../../services/user.service';
import { SharedService } from '../../../services/shared.service';
import { LeapmotorUserDTO } from '../../../models/user-dto';
import { Item, MenuDTO } from '../../../models/menu-dto';
import { AuthJwtService } from '../../../services/auth-jwt.service';
import { TrackingService } from '../../../services/tracking.service';
import { LogType } from '../../../enums/logtype';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',

})
export class SidebarComponent {

  user!: LeapmotorUserDTO;
  menu!: MenuDTO;
  items!: Item[];

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private authJwtService: AuthJwtService,
    private userService: UserService,
    private trackingService: TrackingService
  ) {
    this.getUser();
    this.getMenu();
  }

  getUser() {
    this.userService.getUserData().subscribe(resp => {
      this.user = resp;
    });
  }

  getMenu() {
    this.sharedService.getMenu().subscribe(resp => {
      this.menu = resp;
      this.items = this.menu.Items;
    });
  }
  logout() {
    this.trackUser(LogType.Logout);
    this.authJwtService.logout();
    this.router.navigate(['/login']);
  }
  trackUser(idLogType: number) {
    this.trackingService.trackUser({ IdLogType: idLogType, Url: this.router.url }).subscribe();
  }
}
